import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.4 5.5c-.573 0-1.1.499-1.1 1.191s.527 1.192 1.1 1.192 1.1-.5 1.1-1.192S19.975 5.5 19.4 5.5m-2.6 1.191C16.8 5.24 17.93 4 19.4 4S22 5.24 22 6.691c0 1.452-1.13 2.692-2.6 2.692q-.282 0-.545-.059l-2.23 4.212c.467.492.75 1.165.75 1.892 0 1.451-1.13 2.69-2.6 2.69s-2.6-1.239-2.6-2.69c0-.6.193-1.163.523-1.618l-2.585-3.616a2.5 2.5 0 0 1-1.433.1l-2.23 4.213c.467.491.75 1.165.75 1.891 0 1.452-1.13 2.692-2.6 2.692S2 17.85 2 16.398s1.13-2.691 2.6-2.691q.282 0 .545.058l2.23-4.212a2.75 2.75 0 0 1-.75-1.891c0-1.452 1.13-2.691 2.6-2.691s2.6 1.24 2.6 2.691c0 .6-.192 1.163-.522 1.617l2.585 3.617a2.5 2.5 0 0 1 1.433-.101l2.23-4.212a2.75 2.75 0 0 1-.75-1.892M4.6 15.207c-.574 0-1.1.499-1.1 1.191s.526 1.192 1.1 1.192 1.1-.5 1.1-1.192-.526-1.191-1.1-1.191m3.525-7.545c0-.692.526-1.191 1.1-1.191s1.1.499 1.1 1.191-.526 1.191-1.1 1.191-1.1-.499-1.1-1.191m6.65 6.574c-.574 0-1.1.499-1.1 1.191s.526 1.192 1.1 1.192 1.1-.5 1.1-1.191c0-.693-.526-1.192-1.1-1.192",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }